/**
 * Converts public error prop shorthands into distinct explicit props.
 * If you need proper type narrowing make sure not to destructure the returned
 * value!
 */ export var getDerivedPropsFromErrorProps = function(param) {
    var error = param.error;
    if (error === true || error === "") {
        return {
            showErrorState: true,
            showErrorMessage: false,
            errorMessage: undefined
        };
    }
    if (typeof error === "string") {
        return {
            showErrorState: true,
            showErrorMessage: true,
            errorMessage: error
        };
    }
    return {
        showErrorState: false,
        showErrorMessage: false,
        errorMessage: undefined
    };
};
